import { atomWithStorage } from 'jotai/utils'
import { type GiftOrderMetadata } from '@/features/purchase/state/GiftOrder/types'
import { GIFT_ORDER_SESSION_STORAGE } from '@/features/purchase/state/GiftOrder/constants'

export const giftOrderMetadataAtom = atomWithStorage<GiftOrderMetadata | null>(
  GIFT_ORDER_SESSION_STORAGE,
  null,
  {
    getItem: (key) => {
      try {
        return JSON.parse(window.sessionStorage.getItem(key) ?? 'null')
      } catch {
        return null
      }
    },
    setItem: (key, value) => window.sessionStorage.setItem(key, JSON.stringify(value)),
    removeItem: (key) => window.sessionStorage.removeItem(key),
  },
  { unstable_getOnInit: true },
)
giftOrderMetadataAtom.debugLabel = 'giftOrderMetadataAtom'
